import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Table,Input } from "reactstrap";
import { ReactComponent as FirmaIcon } from "../../../../assets/icons/HorasExtras/firma.svg"
import { ReactComponent as Iconfile } from "../../../../assets/icons/HorasExtras/fileCheck.svg"
import { ReactComponent as PDFIcon } from "../../../../assets/icons/HorasExtras/PDF.svg"
import { ReactComponent as IconAlertPDF } from "../../../../assets/icons/HorasExtras/AlertaDoc.svg"
import { ReactComponent as IconReversar } from "../../../../assets/icons/HorasExtras/Reversar.svg";
import { showAlert, showAlertAviso } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import { FirmarDocumentoPE, ObtenerDocumentos, ReversarDocumento, VistaPreviaPagoEspol } from "./funtionsDocumentoPagoEspolHE";
import ModalFirmarPDF from "components/Varios/Modals/ModalFirmarPDF";
import { InfoDoc } from "./typesDocumentoPagoEspolHE";
import { listadoMeses } from "functions/DatesFunctions";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";
import ModalCargando from "components/Varios/ModalCargando";
import Swal from "sweetalert2";
import { authenticationService } from "services/authentication.service"
import { ROL_NOMINA_TH_HE } from 'Context/SideBarContext';

export function DocumentoPagoEspolHE() {
    const fechaActual = new Date();
    const [urlDocFirma, seturlDocFirma] = useState<string>("");
    const [loading, setloading] = useState<boolean>(false);
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);
    const [infoDoc, setinfoDoc] = useState<InfoDoc[] | null>(null);
    const [urlDocFirmado, seturlDocFirmado] = useState<string>("");

    const [idDoc, setidDoc] = useState<number | null>(null);
    const [mes, setmes] = useState<number | null>(null);
    const [anio, setanio] = useState<number | null>(null);
    const [estadoDocumento, setestadoDocumento] = useState<string>("");

    const estadoElaborado = "ET";
    const estadoRevisado = "RT";
    const estadodFirmadoDTH = "FD";
    const estadoFirmadoJP = "FJ";
    const estadoFirmadoGF = "FF";
    const estadoFirmadoGA = "FA";
    const estadoReversada = "RV";

    useEffect(() => {
        var fecha = new Date();
        if (estadoDocumento != "" && mes && idDoc != null) {
            VistaDocumentoFirmaEspol(estadoDocumento, mes, fecha.getFullYear(), idDoc);
        }
        else {
            DocumentosTabla(fecha.getFullYear());
        }
    }, [estadoDocumento, idDoc])

    useEffect(() => {
        const listaroles: string[] = authenticationService.currentUserValue.roles_usuario;
        if (!listaroles.includes(ROL_NOMINA_TH_HE))
            window.location.href = "https://th.espol.edu.ec/directivo/firmadocumentosdirectivo";
        //window.location.href = "https://th.espol.edu.ec/responsable-th/firmadocumentoth";
        else {
            var fecha = new Date();
            setanio(fecha.getFullYear());
            DocumentosTabla(fecha.getFullYear());
        }
    }, [])


    const ChangeYearDocs = (anio:number) => {
        setanio(anio);
        DocumentosTabla(anio);
    }

    async function VistaDocumentoFirmaEspol(estado: string, mes: number, anio: number, idDocumento: number) {
        setloading(true)
        const respuestaVistaPrevia = await VistaPreviaPagoEspol(estado, mes, anio, idDocumento);

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
            seturlDocFirma(respuestaVistaPrevia.dataResponse)
        }
        else if (respuestaVistaPrevia.status == 409) {
            showAlertAviso(typeof respuestaVistaPrevia.errorMessage === 'string' ? respuestaVistaPrevia.errorMessage : 'Error desconocido');
            setestadoDocumento("");
            setidDoc(null);
        }
        else {

            showAlert(respuestaVistaPrevia.errorMessage ?? "", false);
            setestadoDocumento("");
            setidDoc(null);
        }
        setloading(false)
    }

    async function VistaDocumentoFirmado(estado: string, mes: number, anio: number, idDocumento: number) {
        setloadingAccion(true)
        const respuestaVistaPrevia = await VistaPreviaPagoEspol(estado, mes, anio, idDocumento);

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
            seturlDocFirmado(respuestaVistaPrevia.dataResponse);
            setestadoDocumento("");
        }
        else if (respuestaVistaPrevia.status == 409) {
            showAlertAviso(typeof respuestaVistaPrevia.errorMessage === 'string' ? respuestaVistaPrevia.errorMessage : 'Error desconocido')
            setestadoDocumento("");
        }
        else {
            showAlert(respuestaVistaPrevia.errorMessage ?? "", false);
            setestadoDocumento("");
        }
        setloadingAccion(false)
    }

    async function FirmarDocumento(estados: string, objeto: any, idDocumento: number | null) {
        var contrasenia = objeto.contrasenia;
        var filesData = objeto.filesEnviar;

        if (contrasenia && filesData.length > 0 && idDocumento) {
            var datosRequest = new FormData();
            datosRequest.append("contrasenia", contrasenia);
            datosRequest.append("idpersona", '0');
            filesData.map((fData) => {
                datosRequest.append("files", fData.file, fData.file.name);
            });
            const estadosJSON = JSON.stringify(estados);
            datosRequest.append("dataServidorSave", estadosJSON);

            var accionRealizada = await FirmarDocumentoPE(datosRequest,idDocumento)
            if (accionRealizada.status === 200) {
                showAlert("El documento se ha firmado y enviado correctamente.", true);
                seturlDocFirma("");
                setestadoDocumento("");
            }
            else if (accionRealizada.status == 409) {
                showAlertAviso(typeof accionRealizada.errorMessage === 'string' ? accionRealizada.errorMessage : 'Error Desconocido, no se pudo firmar');
                seturlDocFirma("");
            }
            else {
                showAlert(accionRealizada.errorMessage ?? "", false);
                seturlDocFirma("");
            }
        }
    }

    async function ReversarDoc(idDoc: number) {
        const texto = `<div class="custom-modal-content">
                        <p>¿Esta seguro que desea Reversar este documento?</p>
                        </div>`;

        const result = await Swal.fire({
            html: texto,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });

        if (result.isConfirmed) {
            setloadingAccion(true);
            const reversoDoc = await ReversarDocumento(idDoc);
            if (reversoDoc.status == 200) {
                showAlert("Se ha reversado el documento correctamente", true);
                var fecha = new Date();
                DocumentosTabla(fecha.getFullYear());
            }
            else if (reversoDoc.status == 409) {
                showAlertAviso(reversoDoc.errorMessage ?? "error desconocido");
            }
            else {
                showAlert(reversoDoc.errorMessage ?? "", false);
            }
            setloadingAccion(false);
        } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
            console.log("Se negó la acción.");
        } else {
            console.log("El modal fue cerrado sin realizar una acción.");
            return;
        }

    }

    async function DocumentosTabla(anio: number) {
        setloading(true)
        const respuestaDoc = await ObtenerDocumentos(anio);
        setloading(false)
        if (respuestaDoc.status == 200 && respuestaDoc.dataResponse) {
            var doc = respuestaDoc.dataResponse;
            doc.map((d) => {
                var nombremes = listadoMeses[d.mes - 1];
                d.mesString = nombremes.mes;
            })
            setinfoDoc(doc);
        }
        else {
            showAlert(respuestaDoc.errorMessage ?? "", false);
        }
    }

    const tabla = useCallback(() => {
        if (infoDoc) {
            return (
                <React.Fragment>
                    <div className="table-responsive">
                        <Table >
                            <thead className="cabeceras_tabla_solicitudes_he" style={{ textAlign: "center" }}>
                                <tr>
                                    <th colSpan={1} align={"center"} > Mes</th>
                                    <th colSpan={1} align={"center"} > Elaborado por: </th>
                                    <th colSpan={1} align={"center"} > Revisado por: </th>
                                    <th colSpan={1} align={"center"} > Certificado por: </th>
                                    <th colSpan={1} align={"center"} > Jefe de Presupuesto </th>
                                    <th colSpan={1} align={"center"} > Gerencia Financiera </th>
                                    <th colSpan={1} align={"center"} > Gerencia Administrativa </th>
                                    <th colSpan={1} align={"center"} > Reversar </th>
                                </tr>
                            </thead>
                            <tbody className="table_firma_doc">
                                {infoDoc.map((id, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            {id.estado.trim() == estadoElaborado &&
                                                (<tr style={{ textAlign: "center" }}>
                                                    <td> {id.mesString} </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoElaborado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoRevisado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadodFirmadoDTH); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoJP); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGF); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGA); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <IconReversar
                                                            className={"icono-red"}
                                                            onClick={() => {
                                                                ReversarDoc(id.idhedocumentopagoespol);
                                                            }}
                                                        />
                                                    </td>
                                                </tr>)
                                            }
                                            {id.estado.trim() == estadoRevisado &&
                                                (<tr style={{ textAlign: "center" }}>
                                                    <td> {id.mesString} </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoElaborado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoRevisado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadodFirmadoDTH); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoJP); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGF); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGA); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <IconReversar
                                                            className={"icono-red"}
                                                            onClick={() => {
                                                                ReversarDoc(id.idhedocumentopagoespol);
                                                            }}
                                                        />
                                                    </td>
                                                </tr>)
                                            }
                                            {id.estado.trim() == estadodFirmadoDTH &&
                                                (<tr style={{ textAlign: "center" }}>
                                                    <td> {id.mesString} </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoElaborado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoRevisado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadodFirmadoDTH); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoJP); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGF); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGA); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <IconReversar
                                                            className={"icono-red"}
                                                            onClick={() => {
                                                                ReversarDoc(id.idhedocumentopagoespol);
                                                            }}
                                                        />
                                                    </td>
                                                </tr>)
                                            }
                                            {id.estado.trim() == estadoFirmadoJP &&
                                                (<tr style={{ textAlign: "center" }}>
                                                    <td> {id.mesString} </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoElaborado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoRevisado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadodFirmadoDTH); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoJP); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGF); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-grey-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGA); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <IconReversar
                                                            className={"icono-red"}
                                                            onClick={() => {
                                                                ReversarDoc(id.idhedocumentopagoespol);
                                                            }}
                                                        />
                                                    </td>
                                                </tr>)
                                            }
                                            {id.estado.trim() == estadoFirmadoGF &&
                                                (<tr style={{ textAlign: "center" }}>
                                                    <td> {id.mesString} </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoElaborado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoRevisado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadodFirmadoDTH); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoJP); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGF); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FirmaIcon
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGA); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <IconReversar
                                                            className={"icono-red"}
                                                            onClick={() => {
                                                                ReversarDoc(id.idhedocumentopagoespol);
                                                            }}
                                                        />
                                                    </td>
                                                </tr>)
                                            }
                                            {id.estado.trim() == estadoFirmadoGA &&
                                                (<tr style={{ textAlign: "center" }}>
                                                    <td> {id.mesString} </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoElaborado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoRevisado); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadodFirmadoDTH); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoJP); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Iconfile
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => { setestadoDocumento(estadoFirmadoGF); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <PDFIcon
                                                            className="icono-blue-2-color"
                                                            style={{ height: 20 }}
                                                            onClick={() => VistaDocumentoFirmado(estadoFirmadoGA, id.mes, id.anio, id.idhedocumentopagoespol)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <IconReversar
                                                            className={"icono-red"}
                                                            onClick={() => {
                                                                ReversarDoc(id.idhedocumentopagoespol);
                                                            }}
                                                        />
                                                    </td>
                                                </tr>)
                                            }
                                            {id.estado.trim() == estadoReversada &&
                                                (<tr style={{ textAlign: "center" }}>
                                                    <td> {id.mesString} </td>
                                                    <td>
                                                        {id.fechahoraelaboradopor != null &&
                                                            <Iconfile
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahoraelaboradopor == null && id.fechahorarevisadopor == null &&
                                                            <IconAlertPDF
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                    </td>
                                                    <td>
                                                        {id.fechahorarevisadopor != null &&
                                                            <Iconfile
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahorarevisadopor == null && id.fechahoradirectorth == null && id.fechahoraelaboradopor != null &&
                                                            <IconAlertPDF
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahorarevisadopor == null && id.fechahoraelaboradopor == null &&
                                                            < FirmaIcon
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                    </td>
                                                    <td>
                                                        {id.fechahoradirectorth != null &&
                                                            <Iconfile
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahoradirectorth == null && id.fechahorarevisadopor != null && id.fechahorapresupuesto == null &&
                                                            <IconAlertPDF
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahoradirectorth == null && id.fechahorarevisadopor == null &&
                                                            < FirmaIcon
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                    </td>
                                                    <td>
                                                        {id.fechahorapresupuesto != null &&
                                                            <Iconfile
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahorapresupuesto == null && id.fechahoradirectorth != null && id.fechahorafinanciero == null &&
                                                            <IconAlertPDF
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahorapresupuesto == null && id.fechahoradirectorth == null &&
                                                            < FirmaIcon
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                    </td>
                                                    <td>
                                                        {id.fechahorafinanciero != null &&
                                                            <Iconfile
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahorafinanciero == null && id.fechahorapresupuesto != null && id.fechahorageradmin == null &&
                                                            <IconAlertPDF
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahorafinanciero == null && id.fechahorapresupuesto == null &&
                                                            < FirmaIcon
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                    </td>
                                                    <td>
                                                        {id.fechahorageradmin == null && id.fechahorafinanciero == null &&
                                                            <FirmaIcon
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }

                                                        {id.fechahorageradmin != null && id.fechahorafinanciero != null &&
                                                            <IconAlertPDF
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                        {id.fechahorageradmin == null && id.fechahorafinanciero != null &&
                                                            <IconAlertPDF
                                                                className="icono-red-color"
                                                                style={{ height: 20 }}
                                                                onClick={() => { setestadoDocumento(estadoReversada); setmes(id.mes); setidDoc(id.idhedocumentopagoespol) }}
                                                            />
                                                        }
                                                    </td>
                                                    <td style={{ fontSize: '0.7rem' }}>
                                                        Reversado
                                                    </td>
                                                </tr>)
                                            }

                                        </React.Fragment>
                                    )
                                })}

                            </tbody>
                        </Table>
                    </div>
                </React.Fragment>
            )
        }
    }, [infoDoc])

    const listanios: number[] = Array.from(
        { length: fechaActual.getFullYear() - 2025 + 1 },
        (_, index) => 2025 + index
    );

    return (
        <React.Fragment>
            <div className={"content"}>
                <div style={{ alignContent: 'center' }} className="titulo_seccion"> REVISION DEL DOCUMENTO DE SOLICITUD DE PAGO DE HORAS EXTRAS DEL AÑO {anio} </div>
                <div  style={{
                    maxWidth:"150px",
                    
                }}>
                    <Input className="clickable" type="select" value={anio} onChange={(e) => ChangeYearDocs(+e.target.value) }>
                    {listanios.map((v,i) => {
                        return (
                            <option value={v}>{v}</option>
                        )
                    })}
                </Input>
                </div>
                
                <br></br>
                <div>
                    {tabla()}
                </div>
            </div>
            <ModalCargando
                show={loadingAccion === true}
                textoCargando='Cargando Datos'
                size='md'
                onClose={() => setloading(false)}
            />

            <ModalVistaPreviaDocumentos
                show={urlDocFirmado !== ""}
                cargandoDatos={loading}
                size='xl'
                tituloModal='Documento Solicitud de Pago Horas Extras Espol'
                onClose={() => seturlDocFirmado("")}
                urlArchivo={urlDocFirmado}
                allHeight={true}
            />
            <ModalFirmarPDF
                show={urlDocFirma !== ""}
                tituloModal='Firma Documento Solicitud de Pago Horas Extras ESPOL'
                admiteFirmaFisica={false}
                size="xl"
                urlArchivo={urlDocFirma}
                onClose={() => seturlDocFirma("")}
                cargandoDatos={loading}
                onClickFirma={async (objeto) => await FirmarDocumento(estadoDocumento, objeto, idDoc)}

            />

        </React.Fragment>
    )

}